// PeanutsPage.js
import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { EnquiryForm } from "./EnquiryForm";
import "./OnionPage.css";
import { productDetails } from "../../components/OurServices";

export const PeanutsPage = () => {
  // Use productname from URL parameters
  const { productname } = useParams();
  
  // Find the product by its productname instead of id
  const product = Object.values(productDetails).find(
    (p) => p.productname === productname
  ) || {};

  const [isFormOpen, setIsFormOpen] = useState(false);

  const openForm = () => {
    setIsFormOpen(true);
  };

  const closeForm = () => {
    setIsFormOpen(false);
  };

  return (
    <section className="product-page-section">
      <div className="product-page-container">
        {/* Image and Product Title */}
        <div className="product-image">
          <img src={product.image} alt={product.title} />
        </div>
        <div className="product-content">
          <h1>{product.title}</h1>
          <p>{product.description}</p>

          {/* Product Specifications Table */}
          <table className="product-specs-table">
            <thead>
              <tr>
                <th>Specification</th>
                <th>Details</th>
              </tr>
            </thead>
            <tbody>
              {Object.entries(product.specifications || {}).map(
                ([key, value], index) => (
                  <tr key={index}>
                    <td>{key}</td>
                    <td>{value}</td>
                  </tr>
                )
              )}
            </tbody>
          </table>

          {/* Action Buttons */}
          <div className="product-action-buttons">
            <button className="request-a-call">
                           <i className="fas fa-phone"></i> Send whatsapp
            </button>
            <button className="send-enquiry" onClick={openForm}>
              <i className="fa fa-envelope"></i> Send Enquiry
            </button>
          </div>

          {/* Enquiry Form Modal */}
          {isFormOpen && <EnquiryForm onClose={closeForm} />}
        </div>
      </div>
    </section>
  );
};
